import React from "react";
import Button from "@material-ui/core/Button";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";

const useStyles = makeThemedStyles("LaunchReport", (theme) => ({
  root: {
    background: "rgba(14, 156, 240, 1)",
    height: "2.85em",
    borderRadius: "0.285em",
    width: "100%",
    color: "#fff !important",
    fontSize: "1.6em",
    textTransform: "none",
    letterSpacing: "0.05px",
    "&:hover": {
      background: "rgba(14, 156, 240, 1)",
    },
  },
  disabled: {
    backgroundColor: "rgba(101, 106, 114, 0.26) !important",
    "&:hover": {
      backgroundColor: "rgba(101, 106, 114, 0.26) !important",
    },
  },
}));

interface Props {
  title: string; // Launch Report
  isDisabled?: boolean;
  onClick: () => void;
}

export default function LaunchReport(props: Props) {
  const classes = useStyles();

  return (
    <Button
      variant="contained"
      disabled={props.isDisabled}
      color="primary"
      classes={classes}
      onClick={() => props?.onClick()}
    >
      {props.title}
    </Button>
  );
}
